import { Skeleton } from "@/components/ui/skeleton";

export const SuggestionDetailSkeleton = () => {
  return (
    <div className="container mx-auto px-8">
      <div className="px-4 py-8">
        {/* Back button */}
        <Skeleton className="h-10 w-24 mb-6" />

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Main Content */}
          <div className="lg:col-span-2 space-y-6">
            <div className="bg-white rounded-lg p-6">
              {/* Contact info */}
              <div className="flex items-center gap-3 mb-6">
                <Skeleton className="w-12 h-12 rounded-full" />
                <Skeleton className="h-6 w-32" />
              </div>

              {/* Suggestion title */}
              <Skeleton className="h-6 w-full mb-4" />

              {/* Date and status */}
              <div className="flex items-center gap-4 mb-6">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-6 w-20" />
              </div>

              {/* Action buttons */}
              <div className="flex gap-2 mb-6">
                <Skeleton className="h-10 w-32" />
                <Skeleton className="h-10 w-32" />
              </div>

              {/* Recommendations section */}
              <Skeleton className="h-6 w-40 mb-4" />
              <div className="space-y-3">
                <Skeleton className="h-32 w-full" />
                <Skeleton className="h-32 w-full" />
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            <div className="bg-white rounded-lg p-6">
              <Skeleton className="h-6 w-32 mb-4" />
              <div className="space-y-3">
                <Skeleton className="h-20 w-full" />
                <Skeleton className="h-20 w-full" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
